import { useEffect } from 'react'

const TIMING = {
  INITIAL_DELAY: 200
}

const ELEMENT_SELECTORS = ['WebComponentContainer-breadcrumb', '[id*="WebComponentContainer-breadcrumb"]', 'ico-breadcrumb']

const findBreadcrumbElement = breadcrumbRef => {
  return document.getElementById(ELEMENT_SELECTORS[0]) || document.querySelector(ELEMENT_SELECTORS[1]) || breadcrumbRef.current || document.querySelector(ELEMENT_SELECTORS[2])
}

const makeFocusable = element => {
  if (!element.hasAttribute('tabindex')) {
    element.setAttribute('tabindex', '-1')
  }
}

const useFocusManagement = (currentStep, breadcrumbRef) => {
  useEffect(() => {
    const handleFocus = () => {
      const targetElement = findBreadcrumbElement(breadcrumbRef)

      if (!targetElement) return

      makeFocusable(targetElement)
      targetElement.focus()
    }

    setTimeout(handleFocus, TIMING.INITIAL_DELAY)
  }, [currentStep, breadcrumbRef])
}

export default useFocusManagement
